import Modal from 'react-bootstrap/Modal';
import ScheduleNewAddConfirmModalData from './ScheduleNewAddConfirmModal';

interface PickupConfirmProps {
    showModal: boolean;
    confirmJobIds: ConfirmJobIdList[];
    saveModal(): void;
    hideModal(): void;
}

interface ConfirmJobIdList {
    jobId: number;
    hasInstall: boolean;    //at least one install for this job - need to show payment method for installs only (prepaid customer)
}

const SchedulePickupConfirmData = (props: PickupConfirmProps) => {
    const saveConfirmDetails = () => {
        props.saveModal();
    }

    const confirmJobDetails = <ScheduleNewAddConfirmModalData jobIds={props.confirmJobIds} systemCompanyId={3} saveDetails={saveConfirmDetails} />

    return (
        <div className="static-modal">
            <Modal size="xl" show={props.showModal} onHide={props.hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Confirm Job Contacts for Pickup</Modal.Title>
                    <button type="button" className="close" onClick={props.hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    {confirmJobDetails }
                </Modal.Body>
                <Modal.Footer>
                    
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default SchedulePickupConfirmData;